import React from 'react';

const CheckIcon = ({ svgRef, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}  width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check-icon lucide-check"><path d="M20 6 9 17l-5-5"/></svg>
);

export default CheckIcon;